window.addEventListener('alpine:init', () => {
  if (window.global.registeredAlpineComponents['carousel']) return;

  function carousel(data = {}) {
    return {
      ...data,

      progress: 0,

      scrollLeft: 0,

      scrollProgress: 0,

      refs: {
        slider: this.$el.querySelector('[x-ref="slider"]'),
        slides: this.$el.querySelector('[x-ref="slides"]') || this.$el.querySelector('[x-ref="slider"]'),
        slideAll: this.$el.querySelectorAll('[x-ref="slide"]')
      },

      init() {
        this.onSliderScroll = this.onSliderScroll.bind(this);

        this.$nextTick(() => this.setProgress());

        this.refs.slider.addEventListener('scroll', this.onSliderScroll);

        var observer = new MutationObserver(() => {
          requestAnimationFrame(() => this.setProgress());
        });

        observer.observe(this.$el, { subtree: true, childList: true });
      },

      destroy() {
        this.refs.slider.removeEventListener('scroll', this.onSliderScroll);
      },

      onSliderScroll() {
        this.setProgress();
      },

      setProgress() {
        this.scrollLeft = this.refs.slider.scrollLeft;

        var scrollerLeft = this.scrollLeft / this.refs.slider.scrollWidth * this.refs.slider.offsetWidth;

        var scrollerWidth = (this.refs.slider.offsetWidth / this.refs.slider.scrollWidth) * this.refs.slider.offsetWidth;

        this.progress = ((scrollerLeft + scrollerWidth) / this.refs.slider.offsetWidth * 100);

        var scrollProgress = Math.round(100 * this.scrollLeft / (this.refs.slider.scrollWidth - this.refs.slider.clientWidth));

        this.scrollProgress = isNaN(scrollProgress) ? 100 : scrollProgress;
      },

      scrollTo(index, behavior = 'auto') {
        this.to((current, offset) => offset * (index - 1), behavior);
      },

      scrollToNext(behavior = 'auto') {
        this.to((current, offset) => current + offset, behavior);
      },

      scrollToPrev(behavior = 'auto') {
        this.to((current, offset) => current - offset, behavior);
      },

      to(strategy, behavior = 'auto') {
        var current = this.scrollLeft;
        var offset = this.refs.slides.firstElementChild.getBoundingClientRect().width;

        this.refs.slider.scrollTo({ left: strategy(current, offset), behavior: behavior });
      },

      checkSlideInView(el) {
        var containerVisibleRight = this.scrollLeft + this.refs.slider.clientWidth;

        var elLeft = el.offsetLeft;
        var elRight = elLeft + el.offsetWidth;

        var visibleLeft = Math.max(elLeft, this.scrollLeft);
        var visibleRight = Math.min(elRight, containerVisibleRight);

        var visibleWidth = Math.max(0, visibleRight - visibleLeft);

        return visibleWidth >= el.offsetWidth / 4;
      },

      getSlideIsActiveState(slideIndex) {
        var slidesLength = this.refs.slideAll.length;

        return (
          this.scrollProgress >= (slideIndex * (100 / slidesLength)) &&
          this.scrollProgress <= ((slideIndex + 1) * (100 / slidesLength))
        );
      }
    };
  };

  Alpine.data('carousel', carousel);

  window.global.registeredAlpineComponents['carousel'] = true;
});
